import {types} from './types';

const initialState = {
    list: {
        list: [],
        countPage: 0
    },
    language: []
}

export function dictionaryReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_GET_LIST_LANGUAGE:
            return { ...state, language: action.payload};
        case types.SET_GET_LIST_DICTIONARY:
            return { ...state, list: action.payload };
        default:
            return state
    }
}